/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListIamRolePermissionsRequest
 */
export interface ListIamRolePermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof ListIamRolePermissionsRequest
     */
    iamRoleId: string;
}

export function ListIamRolePermissionsRequestFromJSON(json: any): ListIamRolePermissionsRequest {
    return ListIamRolePermissionsRequestFromJSONTyped(json, false);
}

export function ListIamRolePermissionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIamRolePermissionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamRoleId': json['iam_role_id'],
    };
}

export function ListIamRolePermissionsRequestToJSON(value?: ListIamRolePermissionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_role_id': value.iamRoleId,
    };
}


